import React from 'react';
import Button from '@material-ui/core/Button';
import makeStyles from '@material-ui/core/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
  option: {
    fontSize: '1.3em',
    minWidth: 150,
    whiteSpace: 'nowrap',
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    display: ({ vertical }: any) => {
      return vertical ? 'block' : 'inherit';
    },
    marginTop: ({ vertical }: any) => {
      return vertical ? theme.spacing(1) : 'inherit';
    },
  },
}));

export default function ButtonSelector({
  name,
  selected,
  onClick,
  className = '',
  vertical = false,
}) {
  const classes = useStyles({ vertical });

  return (
    <Button
      color={selected ? 'primary' : 'default'}
      variant={selected ? 'contained' : 'text'}
      className={`${classes.option} ${className} `}
      onClick={onClick}
    >
      {name}
    </Button>
  );
}
